export const LayerNameUtil = {
  Satellite: "Satellite",
  Street: "Street",
} as const;

export type LayerName = typeof LayerNameUtil[keyof typeof LayerNameUtil];
